module.exports = __webpack_public_path__ + "media/images/social-facebook-2a2ee8ec16c154b7645baa7ef4a90b69.svg";